/**
 * ErrorServicio.js
 * @author Nicolás Panaino
 */

//Dependencies
import React, { Component } from 'react';
import { connect } from 'react-redux'
import $ from 'jquery';
import { disableRiesgoNet } from '../../../actions/actions';

//material-ui
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

//Assets
import error from '../../../static/img/404.png';

//Services
import { processToken } from './../services/tokenService';
import { processFlow } from './../services/flowService';
import { processIdClientAnalytics } from './../services/pixelService';

//Components
import { Layout } from '../layout/Layout';

class ErrorServicio extends Component {

    constructor(props) {
        super(props);
        this.state = { }
    }

    componentWillMount() {
        if (this.props.riesgoNetEnabled) {
            this.props.dispatch(
                disableRiesgoNet()
            );
        } else {
            this.validateFlow();
        }
        this.validateToken();
        processIdClientAnalytics('error-servicio');
    }

    componentDidMount() {
        $(".load").fadeOut(700);
    }

    validateFlow() {
        processFlow(this.props.history, this.state.paso);
    }

    validateToken() {
        processToken(this.props.history);
    }

    render() {
        const footer = {
            button: {
                text : "responder preguntas",
                link: this.props.riesgoURLNet
            }
        };
        const body = { img : { src : error } }
        return (
            <Layout footer={footer} body={body}
                tieneFooter>
                <Grid container 
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Grid item xs={12} >
                        <div className="content-description">
                            <h5 className="title" >Ups… algo falló</h5>
                            <h6 className="description">Para poder continuar, te haremos algunas<br/> preguntas personales.</h6>
                        </div>
                    </Grid>
                </Grid>
            </Layout>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        riesgoURLNet: state.riesgoURLNet.url,
        riesgoNetEnabled: state.riesgoNetEnabler.enable,
        flujo: state.navigation.flujo,
        paso: state.navigation.paso,
        token: state.token.id
    }
}

export default connect(mapStateToProps)(ErrorServicio);


// WEBPACK FOOTER //
// ./src/components/OnBoarding/error/ErrorServicio.js